import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import './Services.css';

const Services = () => {
  return (
    <div className="services-page">
      <Helmet>
        <title>Palvelut - Kotisiivous, senioriapu ja kotipalvelut Lahdessa | Sipelius Kotipalvelu</title>
        <meta name="description" content="Kattavat kotipalvelut ja senioripalvelut Lahdessa, Hollolassa, Heinolassa ja Orimattilassa: kotisiivous, senioriapu, henkilökohtainen apu, piha- ja puutarhatyöt sekä viriketoiminta. 38€/tunti." />
        <meta name="keywords" content="kotisiivous Lahti, kotipalvelu Lahti, senioriapu Lahti, senioripalvelut Lahti, kotisiivous Hollola, kotipalvelu Hollola, kotipalvelu Heinola, kotipalvelu Orimattila, pihatyöt, henkilökohtainen apu, viriketoiminta, kodinhoito" />
        <link rel="canonical" href="https://sipelius-kotipalvelu.fi/palvelut" />
        <meta property="og:title" content="Palvelut - Kotisiivous, senioriapu ja kotipalvelut | Lahti, Hollola, Heinola" />
        <meta property="og:description" content="Kattavat kotipalvelut ja senioripalvelut Lahdessa, Hollolassa, Heinolassa ja Orimattilassa: kotisiivous, senioriapu, henkilökohtainen apu, pihatyöt ja viriketoiminta. 38€/tunti." />
        <meta property="og:url" content="https://sipelius-kotipalvelu.fi/palvelut" />
        <meta property="og:type" content="website" />
      </Helmet>
      <section className="services-hero">
        <div className="container">
          <h1>Palvelut</h1>
          <p className="hero-subtitle">
            Tarjoan laadukkaita kotipalveluita, kotisiivousta ja senioriapua Lahdessa, Hollolassa, Heinolassa ja Orimattilassa
          </p>
        </div>
      </section>

      <section className="services-details">
        <div className="container">
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24 4L26.5 16.5H39.5L28.75 25.5L31.25 38L24 29.5L16.75 38L19.25 25.5L8.5 16.5H21.5L24 4Z" fill="#bd8855"/>
                </svg>
              </div>
              <h3>Siivous</h3>
              <p>
                Perusteellinen kodin siivous sisältäen pintojen pyyhkimisen, imuroinnin, 
                lattioiden pesun ja muut kodin yleishuoltotyöt. Räätälöin siivouspalvelut 
                juuri sinun tarpeidesi mukaiseksi.
              </p>
              <ul>
                <li>Kodinsiivous</li>
                <li>Ikkunanpesut</li>
                <li>Vaatehuolto</li>
                <li>Lakanoiden vaihtaminen</li>
                <li>Pintojen pyyhkiminen ja pölyjen poisto</li>
                <li>Imurointi ja lattioiden pesu</li>
              </ul>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24 4C12.95 4 4 12.95 4 24C4 35.05 12.95 44 24 44C35.05 44 44 35.05 44 24C44 12.95 35.05 4 24 4ZM24 40C15.18 40 8 32.82 8 24C8 15.18 15.18 8 24 8C32.82 8 40 15.18 40 24C40 32.82 32.82 40 24 40Z" fill="#bd8855"/>
                  <path d="M24 12C17.37 12 12 17.37 12 24C12 30.63 17.37 36 24 36C30.63 36 36 30.63 36 24C36 17.37 30.63 12 24 12ZM24 32C19.59 32 16 28.41 16 24C16 19.59 19.59 16 24 16C28.41 16 32 19.59 32 24C32 28.41 28.41 32 24 32Z" fill="#bd8855"/>
                </svg>
              </div>
              <h3>Senioriapu</h3>
              <p>
                Senioripalvelut räätälöitynä tarpeisiisi: henkilökohtaista apua ja tukea senioreille arjen askareissa.
                Autan peseytymisessä, pukeutumisessa, asioinnissa ja muissa
                päivittäisissä toiminnoissa.
              </p>
              <ul>
                <li>Peseytymisapu ja hygienia</li>
                <li>Pukeutumisapu</li>
                <li>Asiointiavustus</li>
                <li>Seura ja keskustelu</li>
              </ul>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24 4C13.5 4 5 12.5 5 23C5 33.5 13.5 42 24 42C34.5 42 43 33.5 43 23C43 12.5 34.5 4 24 4ZM24 38C15.7 38 9 31.3 9 23C9 14.7 15.7 8 24 8C32.3 8 39 14.7 39 23C39 31.3 32.3 38 24 38Z" fill="#bd8855"/>
                  <path d="M24 12L26 18H32L27 22L29 28L24 24L19 28L21 22L16 18H22L24 12Z" fill="#bd8855"/>
                </svg>
              </div>
              <h3>Piha- ja puutarhatyöt</h3>
              <p>
                Autan piha- ja puutarhatöissä ympäri vuoden. Nurmikon leikkauksesta 
                kukkien hoitoon ja talvikunnossapitoon - teen pihatöitä ammattitaidolla 
                ja huolellisuudella.
              </p>
              <ul>
                <li>Nurmikon leikkaus (asiakkaan ruohonleikkurilla)</li>
                <li>Kukkien istutus ja hoito</li>
                <li>Pensasaitojen leikkaus</li>
                <li>Lumen kolaus ja hiekoitus tarvittaessa</li>
              </ul>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24 4L28 16H40L30 24L34 36L24 28L14 36L18 24L8 16H20L24 4Z" fill="#bd8855"/>
                </svg>
              </div>
              <h3>Henkilökohtainen apu</h3>
              <p>
                Yksilöllistä apua erilaisissa arjen askareissa. Autan sinua 
                niissä asioissa, joissa tarvitset tukea, ja teen sen 
                ammattitaitoisesti ja huolellisesti.
              </p>
              <ul>
                <li>Asiointiapu</li>
                <li>Ruokailussa avustaminen</li>
                <li>Ruoanvalmistaminen</li>
                <li>Suihkuapu</li>
                <li>Saunomisessa avustaminen</li>
                <li>Lemmikkien hoito ja ulkoilutus</li>
                <li>Lääkärikäynnit ja terveydenhuolto</li>
                <li>Pankki- ja virastoasiointi</li>
              </ul>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24 4C12.95 4 4 12.95 4 24C4 35.05 12.95 44 24 44C35.05 44 44 35.05 44 24C44 12.95 35.05 4 24 4ZM20 32L12 24L14.83 21.17L20 26.34L33.17 13.17L36 16L20 32Z" fill="#bd8855"/>
                </svg>
              </div>
              <h3>Viriketoiminta</h3>
              <p>
                Järjestän ja ideoin viriketoimintaa tarpeen mukaan niin asiakkailleni 
                kuin yrityksille. Tarjoan seuraa ja tukea digitaalisten laitteiden 
                käytössä sekä miellyttävää seuranpitoa.
              </p>
              <ul>
                <li>Digiohjaus</li>
                <li>Seuranpito ikäihmiselle</li>
                <li>Räätälöidyt aktiviteetit</li>
                <li>Yrityksille suunnattu viriketoiminta</li>
                <li>Henkilökohtainen palvelusuhde</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <h2>Haluatko tarkemman tarjouksen?</h2>
          <p>Ota yhteyttä niin keskustellaan tarpeistasi ja teen sinulle yksilöllisen tarjouksen juuri sinun tilanteeseesi sopivaksi. <Link to="/hinnasto">Tutustu hinnaston</Link> ja <Link to="/yhteystiedot">ota yhteyttä</Link> saadaksesi lisätietoja.</p>
          <div className="cta-buttons">
            <a href="mailto:sipeliuskotipalvelu@gmail.com" className="cta-button primary">
              Lähetä viesti
            </a>
            <a href="tel:0442465506" className="cta-button secondary">
              Soita nyt
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services; 